module.exports = __webpack_public_path__ + "static/media/60.e95572be.mp3";